// src/components/Layouts/CommonModalLayout.jsx
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { modalOverlayStyles, modalContentStyles } from '../../styles/commonStyles';
import CloseButton from '../Buttons/CloseButton';
import ErrorMessage from '../Common/ErrorMessage';

const CommonModalLayout = ({ 
    isOpen, 
    onClose, 
    title, 
    children, 
    closeOnOverlayClick = true, 
    customStyles,
    showCloseButton = true,
    errorMessage = null,
    hideOverlay = false
}) => {
    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    return isOpen ? createPortal(
        <>
            {!hideOverlay && (
                <div 
                    className={modalOverlayStyles} 
                    onClick={() => closeOnOverlayClick && onClose()} 
                />
            )}
            <div className={customStyles || modalContentStyles}>
                {(title || showCloseButton) && (
                    <div className="flex items-start justify-between mb-4">
                        {title && <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-200 leading-none mt-1">{title}</h2>}
                        {showCloseButton && (
                            <div className="-mt-1 -mr-1">
                                <CloseButton onClick={onClose} />
                            </div>
                        )}
                    </div>
                )}
                {Array.isArray(children) && children.length > 1
                    ? <>
                        {children.slice(0, -1)}
                        {errorMessage && <ErrorMessage message={errorMessage} />}
                        {children[children.length - 1]}
                      </>
                    : <>
                        {errorMessage && <ErrorMessage message={errorMessage} />}
                        {children}
                      </>
                }
            </div>
        </>,
        document.body
    ) : null;
};

export default CommonModalLayout;